var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66667 7.16683V5.50016C3.66667 3.19898 5.53215 1.3335 7.83333 1.3335C10.1345 1.3335 12 3.19898 12 5.50016V7.16683C12.9205 7.16683 13.6667 7.91302 13.6667 8.8335V13.0002C13.6667 13.9206 12.9205 14.6668 12 14.6668H3.66667C2.74619 14.6668 2 13.9206 2 13.0002V8.8335C2 7.91302 2.74619 7.16683 3.66667 7.16683ZM10.3333 5.50016V7.16683H5.33333V5.50016C5.33333 4.11945 6.45262 3.00016 7.83333 3.00016C9.21405 3.00016 10.3333 4.11945 10.3333 5.50016Z",
    fill: "#823FC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLock);
export default __webpack_public_path__ + "static/media/purple-lock.268394a79d4de499aeb0f8270111b9cc.svg";
export { ForwardRef as ReactComponent };